import React from 'react';
import { HeroSection } from './components/HeroSection';
import { CountdownTimer } from './components/CountdownTimer';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { ProductContents } from './components/ProductContents';
import { WhoIsThisFor } from './components/WhoIsThisFor';
import { FAQSection } from './components/FAQSection';
import { PriceBlock } from './components/PriceBlock';
import { FloatingCTA } from './components/FloatingCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-creme font-sans text-dark-coffee selection:bg-warm-accent/20" data-id="element-0">
      <CountdownTimer data-id="element-1" />
      <main className="relative overflow-hidden" data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <ProductContents data-id="element-6" />
        <WhoIsThisFor data-id="element-7" />
        <FAQSection data-id="element-8" />
        <PriceBlock data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
      <FloatingCTA data-id="element-11" />
    </div>;
}